import { LabeledRow } from "@components/LabeledRow";
import { CaseCustomer, LawsuitInfo, Stakeholder } from "@customTypes/responses/lawsuit";
import React from "react";
import { MoreInvolvedButton } from "./style";
import { captalizeFirstLetter } from "@helpers/stringHelpers";
import { isStakeholder } from "@customTypes/typeGuards";
import { InfoRow } from "@components/styles/dataDisplay";
import { FaChevronUp } from "@react-icons/all-files/fa/FaChevronUp";
import { FaChevronDown } from "@react-icons/all-files/fa/FaChevronDown";

type InvolvedPeopleProps = {
  stakeholders: LawsuitInfo["stakeholder"];
  customers: LawsuitInfo["customers"];
};

type RenderInvolvedPeopleProps = {
  people?: (Stakeholder | CaseCustomer)[];
};

const RenderInvolvedPeople: React.FC<RenderInvolvedPeopleProps> = ({ people }) => {
  const componentsToRender = people.map((person) => {
    if (isStakeholder(person)) {
      return (
        <LabeledRow
          key={person.contactId}
          label={captalizeFirstLetter(person.stakeholderRoleName)}
          value={person.contactName}
        />
      );
    } else {
      return (
        <LabeledRow
          key={person.id}
          label={captalizeFirstLetter(person.roleName) ?? "Autor"}
          value={person.name}
        />
      );
    }
  });

  return <>{componentsToRender}</>;
};

const InvolvedPeople: React.FC<InvolvedPeopleProps> = ({ stakeholders, customers }) => {
  const [isExpanded, setIsExpanded] = React.useState(false);
  const MAXIMUM_INVOLVED_PEOPLE = 5;

  const involvedPeople = stakeholders?.length + customers?.length;
  const shouldExpand = involvedPeople > MAXIMUM_INVOLVED_PEOPLE;
  const involvedPeopleArray = [...customers, ...stakeholders];

  const handleClick = () => {
    setIsExpanded((current) => !current);
  };

  return (
    <>
      <RenderInvolvedPeople
        people={involvedPeopleArray.slice(0, MAXIMUM_INVOLVED_PEOPLE)}
        key="initial_involved"
      />
      {isExpanded && (
        <RenderInvolvedPeople
          people={involvedPeopleArray.slice(MAXIMUM_INVOLVED_PEOPLE)}
          key="expanded_involved"
        />
      )}

      {shouldExpand && (
        <InfoRow>
          <div />
          <MoreInvolvedButton onClick={handleClick}>
            {isExpanded ? "Ver menos envolvidos" : "Ver mais envolvidos"}
            {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
          </MoreInvolvedButton>
        </InfoRow>
      )}
    </>
  );
};

export default InvolvedPeople;
